import { IconButton } from '@mui/material';   
import { Description } from '@mui/icons-material';
import xlsIcon from './xls-icon.svg'
import pdfIcon from './pdf.svg'
import docxIcon from './docx2.png'
import imageIcon from './image.svg'
import csvIcon from './csv.svg'
import pptxIcon from './pptx.png'

const FileIcon = ({ fileExtension, size = 'sm' }) => {
  switch (fileExtension) {
    case 'pptx':
      return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={pptxIcon} height="24px"></img>
    </IconButton>;
    case 'csv':
      return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={csvIcon} height="24px"></img>
    </IconButton>;
    case 'pdf':
      return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
        <img src={pdfIcon} height="24px"></img>
      </IconButton>;
    case 'doc':
    case 'docx':
    case 'pages':
      return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
        <img src={docxIcon} height="24px"></img>
      </IconButton>;
    case 'xls':
    case 'xlsx':
    case 'numbers':
      return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
        <img src={xlsIcon} height="24px"></img>
      </IconButton>;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'svg':
      return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
        <img src={imageIcon} height="24px"></img>
      </IconButton>;
  }

  return FileIconBasedOnMimeType(fileExtension);

};

const FileIconBasedOnMimeType = (mimeType) => {
  if (mimeType.startsWith('image/')) {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={imageIcon} height="24px"></img>
    </IconButton>;
  }

  if (mimeType === 'application/pdf') {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={pdfIcon} height="24px"></img>
    </IconButton>;
  }

  if (mimeType.startsWith('text/')) {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={docxIcon} height="24px"></img>
    </IconButton>;
  }

  if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={xlsIcon} height="24px"></img>
    </IconButton>;
  }

  if (mimeType === 'application/vnd.ms-powerpoint') {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={pptxIcon} height="24px"></img>
    </IconButton>;
  }

  if (mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={pptxIcon} height="24px"></img>
    </IconButton>;
  }

  if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={docxIcon} height="24px"></img>
    </IconButton>;
  }

  if (mimeType === 'application/vnd.ms-excel') {
    return <IconButton sx={{ height:"24px", width:"24px", padding:0, "&:hover": { backgroundColor: "transparent"} }}>
      <img src={xlsIcon} height="24px"></img>
    </IconButton>;
  }

  return <IconButton sx={{ padding:0, "&:hover": { backgroundColor: "transparent"} }}>
    <Description sx={{ padding:0, fontSize: 28, color: "#B71518" }}/>
  </IconButton>;
}

export default FileIcon;
